import { setSession } from '@/common/js/api'
import {
  splicing,
  formatDate,
  getKeyOfData,
  clearTagOfData,
  trim,
  isArray,
  isEmpty,
  timeout,
  dateReplace,
  pullKeys,
  getByteLen,
  deepCopy,
  betweenTime
} from '@/common/js/utils'

import { bidSuggest, actionId2Word } from '@/api/toutiao.model'
import { addTargeting, updateTargeting } from '@/api/manage.model'

import cityData from '@/data/toutiao/city_province'
import articleData from '@/data/toutiao/article_categroy'
import brandData from '@/data/toutiao/brand_categroy'
import brandDataAll from '@/data/toutiao/brand_all_categroy'
import tagsData from '@/data/toutiao/ad_tag'
import gategoryData from '@/data/toutiao/app_categroy'
import autotendData from '@/data/toutiao/auto_extend_targets'
import androidVersion from '@/data/toutiao/android_version'
import iOSVersion from '@/data/toutiao/ios_version'
import shortcuts from '@/data/toutiao/shortcuts'
import convertData, { reserveConvertData } from '@/data/toutiao/convert_data'

import TextareaLen from '@/components/input/textarea-len.vue'
import DragWeektime from '@/components/drag/drag-weektime.vue'
import SelectTargeter from '@/components/select/select-target.vue'
import InputRange from '@/components/input/input-number-range'
import Retarget from '@/components/retarget/retarget.vue'
import Targeting from '@/views/create/toutiaonew_local/components/targeting/'
import Suggest from '@/views/create/toutiao_local/components/suggest.vue'
import SuggestBudget from '@/views/create/toutiao_local/components/suggest-budget.vue'
import SiteLandpage from '@/components/landpage/site-landpage.vue'
import SwitchPlus from '@/components/switch-plus'

const disabledDate = (date) => {
  return date && date.valueOf() < Date.now() - 86400000
}

// 处理7*48位值
const getWeektime = (val) => {
  return val
    .map((item) => {
      return item.child.map((ret) => (ret.check ? '1' : '0')).join('')
    })
    .join('')
}

export default {
  components: {
    DragWeektime,
    TextareaLen,
    Retarget,
    // Targeting,
    SelectTargeter,
    SuggestBudget,
    Suggest,
    InputRange,
    SwitchPlus,
    SiteLandpage
  },
  computed: {
    editState() {
      return this.$route.query.t === 'edit'
    },
    platformGameData() {
      return this.dataGames.filter((ret) => ret.ch_platform_id === this.formItem.ch_platform_id)
    },
    mult_timeRange() {
      const arr = []
      this.formItem.weektimeData.forEach((item) => {
        arr.push({
          id: item.row,
          week: item.value,
          value: splicing(item.child)
        })
      })
      return arr
    }
  },
  data() {
    return {
      asyning: null, // 保存定向
      pricing: null, // 建议出价动画
      suggestStat: null, // 建议出价
      suggestRange: [], // 建议预算范围

      // 基础信息
      targetPlan: [], // 定向管理

      // 用户定向
      cityData: cityData,
      tagsData: tagsData,
      gategoryData: gategoryData,
      brandData: brandData,
      brandDataAll: brandDataAll,
      articleData: articleData,
      autotendData: autotendData,
      androidVersion: androidVersion,
      iOSVersion: iOSVersion,

      // 预算与出价
      datetime: [],
      datetimeOption: { shortcuts, disabledDate }, // 快速选择配置
      disableTotal: null, // 是否采用总预算
      weektimeData: [],

      // 计划信息
      info: null,
      saveTargetModel: false,
      saveTitle: '',
      saveDesc: '',
      appDownloadConvertData: convertData, // 应用下载的转化参数
      reserveConvertData // 预约下载的转化参数
    }
  },
  watch: {
    // 投放时间段 今日头条提交参数处理
    mult_timeRange: {
      handler(nVal) {
        this.formItem.delivery_setting.schedule_time = getWeektime(this.formItem.weektimeData)
      },
      deep: true
    },
    // 'formItem.weektimeData' (nVal) {
    //   if (nVal) {
    //     console.log('week')
    //     this.formItem.delivery_setting.schedule_time = getWeektime(nVal)
    //   }
    // },
    'formItem.ch_platform_id'(nVal) {
      if (nVal === 1) {
        this.formItem.app_type = 'APP_ANDROID'
        // this.$set(this.curTarget, 'platform', ['ANDROID'])
      } else if (nVal === 2) {
        this.formItem.app_type = 'APP_IOS'
        // this.$set(this.curTarget, 'platform', ['IOS'])
      }
    },
    'formItem.landing_type'(nVal) {
      if (nVal === 'APP') {
        this.formItem.download_type = 'DOWNLOAD_URL'
        this.formItem.app_type = this.formItem.ch_platform_id === 1 ? 'APP_ANDROID' : 'APP_IOS'
      } else if (nVal === 'LINK') this.formItem.download_type = 'EXTERNAL_URL'
    },
    'formItem.cpa_bid'(nVal) {
      if (nVal) this.formItem.bid = nVal
    },
    'formItem.adjust_cpa'(nVal) {
      this.formItem.hideBid = nVal === 0
    }
  },
  methods: {
    async id2word(cate_ids, word_ids, day, scene) {
      const params = {}
      const getWords = []
      // 行为
      if (day) {
        Object.assign(params, {
          ad_account_id: this.account,
          targeting_type: 'ACTION',
          action_scene: scene.join(','),
          action_days: day
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      } else {
        Object.assign(params, {
          ad_account_id: this.account,
          targeting_type: 'INTEREST'
        })
        cate_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: cate_ids.join(','), tag_type: 'CATEGORY' })))
        word_ids.length && getWords.push(actionId2Word(Object.assign({}, params, { ids: word_ids.join(','), tag_type: 'KEYWORD' })))
      }
      const data = await Promise.all(getWords)
      const [cates, words] = data
      let cate_tags = []
      let word_tags = []
      if (cates && isArray(cates.categories)) {
        cate_tags = cates.categories.map((ret) => {
          ret.type = 'CATEGORY'
          return ret
        })
      }
      if (words && isArray(words.keywords)) {
        word_tags = words.keywords.map((ret) => {
          ret.type = 'KEYWORD'
          return ret
        })
      }
      if (day) return [...cate_tags, ...word_tags]
      else return [...cate_tags, ...word_tags]
    },
    reverWeektime(schedule) {
      let idx = 0
      for (let i = 0; i < this.formItem.weektimeData.length; i++) {
        const children = this.formItem.weektimeData[i].child
        for (let j = 0; j < children.length; j++) {
          const n = schedule.substr(idx, 1)
          this.$set(this.formItem.weektimeData[i].child[j], 'check', Boolean(parseInt(n)))
          idx++
        }
      }
    },
    asyncOK() {
      if (this.saveTitle) {
        if (this.saveTitle.length > 100) {
          this.$Message.error('定向标题不能超过字符限制')
          return
        }
        if (this.saveDesc.length > 300) {
          this.$Message.error('定向描述不能超过字符限制')
          return
        }
        // 手机价格不能相同
        if (isArray(this.curTarget.launch_price) && this.curTarget.launch_price[0] === this.curTarget.launch_price[1]) {
          this.$Message.error('请输入正确的手机价格区间！首尾价格不能相等')
          return
        }
        const targetingParam = JSON.parse(JSON.stringify(this.curTarget))
        const { retargeting_tags, audiences, media_retargeting_tags, mediaAudiences } = targetingParam
        const { includes, excludes } = retargeting_tags.pop()
        const { mediaExcludes, mediaIncludes } = media_retargeting_tags.pop()
        if (audiences) {
          const { retargeting_tags_include, retargeting_tags_exclude } = audiences
          targetingParam.includes = includes
          targetingParam.excludes = excludes
          targetingParam.retargeting_tags_include = retargeting_tags_include
          targetingParam.retargeting_tags_exclude = retargeting_tags_exclude
        }
        if (mediaAudiences) {
          const { flow_package, exclude_flow_package } = mediaAudiences
          targetingParam.mediaExcludes = mediaExcludes
          targetingParam.mediaIncludes = mediaIncludes
          targetingParam.flow_package = flow_package
          targetingParam.exclude_flow_package = exclude_flow_package
        }
        targetingParam.platform = this.formItem.app_type === 'APP_ANDROID' ? ['ANDROID'] : ['IOS']
        delete targetingParam.retargeting_tags
        const params = {
          mediaId: this.media,
          targetingId: this.saveTargetingId || undefined,
          targetingName: this.saveTitle,
          targetingDesc: this.saveDesc,
          targetingParam: JSON.stringify(targetingParam)
        }
        this.asyning = true
        if (isEmpty(params.targetingId)) {
          addTargeting(params).then((data) => {
            this.asyning = false
            if (data) {
              this.cannelSave()
              this.$Message.success('保存定向成功！')
            }
          })
        } else {
          updateTargeting(params).then((data) => {
            this.asyning = false
            if (data) {
              this.cannelSave()
              this.$Message.success('修改定向成功！')
            }
          })
        }
      } else this.$Message.error('定向标题不能为空')
    },
    cannelSave() {
      this.saveTitle = ''
      this.saveDesc = ''
      this.saveTargetModel = false
    },
    gameChange() {
      this.formItem.game_id = ''
      this.$set(this.curTarget, 'android_osv', '0.0')
      this.$set(this.curTarget, 'app_behavior_target', 'NONE')
      this.$set(this.curTarget, 'app_behavior_target', 'NONE')
      clearTagOfData(this.brandData, this)
      clearTagOfData(this.brandDataAll, this)
      clearTagOfData(this.gategoryData, this)
    },
    changLandType(val) {
      if (val === 'APP') this.formItem.land_page_id = undefined
      else if (val === 'LINK') this.formItem.land_page_id = ''
      this.formItem.page_addr = ''
    },
    // 选择游戏
    handleGame(meta) {
      this.formItem.game_id = meta.id
      this.formItem.package = meta.ad_package // 更改成显示包名
      this.formItem.download_url = meta.game_address // 包下载地址|落地页
    },
    targetPlanChange(val) {
      const targetPlan = this.targetPlan.filter((ret) => ret.check).pop()
      this.$set(targetPlan, 'targetingName', val)
    },
    // 定向还原默认值
    targetRadioChange(key) {
      this.radioChange(key)
    },
    // 定向mixcheck还原
    targetMultChange({ key, value }) {
      this.multRadioChange(value, key)
    },
    // 人群包选定
    audienceRadioChange({ item, account, type, audience }) {
      if (audience === 'clear') {
        // 清空人群包 单账号
        const tags = this.curTarget.retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1) {
          this.$set(tags[index], 'includes', [])
          this.$set(tags[index], 'excludes', [])
        }
        if (this.$refs.targeting) {
          this.$refs.targeting.resetAudience()
          this.$refs.targeting.currentRetarget(account)
        }
      } else {
        if (item.select !== type) {
          const tags = this.curTarget.retargeting_tags
          const index = tags.findIndex((ret) => ret.id === account)
          if (index > -1 && type === 'include') {
            if (audience === 'append') {
              const idx = tags[index].excludes.findIndex((met) => met.id === item.id)
              if (idx > -1) tags[index].excludes.splice(idx, 1)
              tags[index].includes.push(item)
            } else {
              const idx = tags[index].includes.findIndex((met) => met.id === item)
              if (idx > -1) tags[index].includes.splice(idx, 1)
            }
          } else if (index > -1 && type === 'exclude') {
            if (audience === 'append') {
              const idx = tags[index].includes.findIndex((met) => met.id === item.id)
              if (idx > -1) tags[index].includes.splice(idx, 1)
              tags[index].excludes.push(item)
            } else {
              const idx = tags[index].excludes.findIndex((met) => met.id === item)
              if (idx > -1) tags[index].excludes.splice(idx, 1)
            }
          }
        }
      }
    },
    audienceSelectAll({ type, check, checkList, account }) {
      const bool = Boolean(check)
      const tags = this.curTarget.retargeting_tags
      const index = tags.findIndex((ret) => ret.id === account)
      const unself = type === 'includes' ? 'excludes' : 'includes'
      if (isArray(tags) && isArray(checkList)) {
        checkList.forEach((ret) => {
          const disbool = type === 'excludes' && ret.source === 'CUSTOM_AUDIENCE_TYPE_THIRD_PARTY'
          !disbool && this.$set(ret, 'select', type.substr(0, type.length - 1))
          if (bool) {
            const idx = tags[index][unself].findIndex((met) => met.id === ret.id)
            const sdx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][unself].splice(idx, 1)
            !disbool && sdx < 0 && tags[index][type].push(ret)
          } else {
            const idx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][type].splice(idx, 1)
          }
        })
      }
    },
    mediaAudienceSelectAll({ type, check, checkList, account }) {
      const bool = Boolean(check)
      const tags = this.curTarget.media_retargeting_tags
      const index = tags.findIndex((ret) => ret.id === account)
      const unself = type === 'mediaIncludes' ? 'mediaExcludes' : 'mediaIncludes'
      if (isArray(tags) && isArray(checkList)) {
        checkList.forEach((ret) => {
          // const disbool = type === 'mediaExcludes'
          this.$set(ret, 'select', type.substr(0, type.length - 1))
          if (bool) {
            const idx = tags[index][unself].findIndex((met) => met.id === ret.id)
            const sdx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][unself].splice(idx, 1)
            sdx < 0 && tags[index][type].push(ret)
          } else {
            const idx = tags[index][type].findIndex((met) => met.id === ret.id)
            if (idx > -1) tags[index][type].splice(idx, 1)
          }
        })
      }
    },
    mediaAudienceRadioChange({ item, account, type, audience }) {
      if (audience === 'clear') {
        // 清空媒体包 单账号
        const tags = this.curTarget.media_retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1) {
          this.$set(tags[index], 'mediaIncludes', [])
          this.$set(tags[index], 'mediaExcludes', [])
        }
        if (this.$refs.targeting) {
          this.$refs.targeting.resetMediaAudience()
          this.$refs.targeting.currentMediaRetarget(account)
        }
      } else if (item.select !== type) {
        const tags = this.curTarget.media_retargeting_tags
        const index = tags.findIndex((ret) => ret.id === account)
        if (index > -1 && type === 'include') {
          if (audience === 'append') {
            if (tags[index].mediaExcludes.length) {
              this.$Modal.confirm({
                title: '确认更改选项',
                content: '媒体定向不支持同时定向且排除操作，更换操作类型后已选流量包会被清空，是否继续？',
                onOk: () => {
                  tags[index].mediaIncludes.push(item)
                  tags[index].mediaExcludes.splice(0, tags[index].mediaExcludes.length)
                }
              })
            } else tags[index].mediaIncludes.push(item)
          } else {
            const idx = tags[index].mediaIncludes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].mediaIncludes.splice(idx, 1)
          }
        } else if (index > -1 && type === 'exclude') {
          if (audience === 'append') {
            if (tags[index].mediaIncludes.length) {
              this.$Modal.confirm({
                title: '确认更改选项',
                content: '媒体定向不支持同时定向且排除操作，更换操作类型后已选流量包会被清空，是否继续？',
                onOk: () => {
                  tags[index].mediaExcludes.push(item)
                  tags[index].mediaIncludes.splice(0, tags[index].mediaIncludes.length)
                }
              })
            } else tags[index].mediaExcludes.push(item)
          } else {
            const idx = tags[index].mediaExcludes.findIndex((met) => met.id === item)
            if (idx > -1) tags[index].mediaExcludes.splice(idx, 1)
          }
        }
      }
    },
    // 版位全选
    selectInventoryAll(check) {
      this.curTarget.inventory_type = check
        ? [
          'INVENTORY_FEED',
          'INVENTORY_VIDEO_FEED',
          'INVENTORY_AWEME_FEED',
          'INVENTORY_TOMATO_NOVEL',
          'INVENTORY_UNION_SLOT',
          'UNION_BOUTIQUE_GAME'
        ]
        : []
    },
    changePricing(val) {
      switch (val) {
        case 'CONVERSION':
          this.formItem.pricing = 'PRICING_OCPM'
          this.formItem.flow_control_mode = 'FLOW_CONTROL_MODE_FAST'
          this.formItem.deep_bid_type = 'DEEP_BID_DEFAULT'
          break
        case 'CLICK':
          this.formItem.pricing = 'PRICING_CPC'
          this.formItem.flow_control_mode = 'FLOW_CONTROL_MODE_SMOOTH'
          this.formItem.deep_bid_type = undefined
          break
        case 'SHOW':
          this.formItem.pricing = 'PRICING_CPM'
          this.formItem.flow_control_mode = 'FLOW_CONTROL_MODE_SMOOTH'
          this.formItem.deep_bid_type = undefined
          break
        case 'PLAY':
          this.formItem.pricing = 'PRICING_CPV'
          this.formItem.flow_control_mode = 'FLOW_CONTROL_MODE_SMOOTH'
          break

        default:
          break
      }
      // 还原建议出价
      this.suggestStat = null
      this.formItem.smart_bid_type = 'SMART_BID_CUSTOM'
      this.smartBidChange('SMART_BID_CUSTOM')
      this.formItem.adjust_cpa = undefined
      this.formItem.bid = ''
    },
    changeAD(val) {
      let ad
      switch (val) {
        case 'PRICING_OCPM':
          ad = 'CONVERSION'
          break
        case 'PRICING_CPC':
          ad = 'CLICK'
          break
        case 'PRICING_CPM':
          ad = 'SHOW'
          break
        case 'PRICING_CPV':
          ad = 'PLAY'
          break

        default:
          break
      }
      return ad
    },
    changeDatetime(val) {
      const start = dateReplace(val[0])
      const end = dateReplace(val[1])
      this.formItem.delivery_setting.start_time = formatDate(start, 'yyyy-MM-dd')
      this.formItem.delivery_setting.end_time = formatDate(end, 'yyyy-MM-dd')
    },
    changeEndTime(val) {
      this.formItem.end_time = formatDate(new Date(val), 'yyyy-MM-dd 23:59')
    },
    changeDeepBid(val) {
      if (val === 'DEEP_BID_MIN' || val === 'AUTO_MIN_SECOND_STAGE') this.formItem.deep_cpabid = ''
      else this.formItem.deep_cpabid = undefined
    },
    changeBidRange(val) {
      if (val) {
        this.formItem.bid_num_range = ['', '']
        this.formItem.bid = ''
        this.formItem.cpa_bid = ''
      }
    },
    changeDeepCpabidRange(val) {
      if (val) {
        this.formItem.deep_cpabid_num_range = ['', '']
        this.formItem.deep_cpabid = ''
      }
    },
    // 清空时间段
    clearWeektime() {
      this.formItem.weektimeData.forEach((item) => {
        item.child.forEach((t) => {
          this.$set(t, 'check', false)
        })
      })
    },
    // 选择橙子建站地址
    selectSiteLandPage(meta) {
      this.formItem.external_url = meta.url
      this.siteModel = false
    },
    inputTrimFour(key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = Number(parseFloat(val).toFixed(4))
      } else val = parseInt(val)
      obj[key] = isEmpty(val) ? 0 : val
    },
    changeDeliveryMode(meta) {
      if (meta === 'PROCEDURAL') {
        // 子目的只支持手动投放
        this.formItem.app_promotion_type = 'DOWNLOAD'

        this.formItem.delivery_setting.bid_type = 'CUSTOM'
        this.formItem.delivery_setting.budget_mode = 'BUDGET_MODE_DAY'
        if (this.formItem.delivery_setting.bid_type === 'NO_BID') this.formItem.delivery_setting.budget_optimize_switch = 'ON'
      }
    },
    changeBidType(meta) {
      if (this.formItem.delivery_mode === 'PROCEDURAL' && meta === 'NO_BID') this.formItem.delivery_setting.budget_optimize_switch = 'ON'
      else this.formItem.delivery_setting.budget_optimize_switch = 'OFF'
    },
    // 切换定向
    setTargeter(index) {
      const item = this.targetPlan[index]
      // 清空原选中
      this.targetPlan.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
      if (item.targetingId) {
        this.saveTargetingId = item.targetingId
        this.saveTitle = item.targetingName
        this.saveDesc = item.targetingDesc
      } else {
        this.saveTargetingId = undefined
        this.saveTitle = ''
        this.saveDesc = ''
      }

      this.show = false
      this.$set(item, 'check', true)
      // 多选值得清空与解析
      this.decompile(item.targetingParam.city, 'cityData')
      this.decompile(item.targetingParam.ad_tag, 'tagsData')
      this.decompile(item.targetingParam.app_category, 'gategoryData')
      this.decompileKey(item.targetingParam.article_category, 'articleData')
      this.decompileKey(item.targetingParam.device_brand, 'brandData')
      this.decompileKey(item.targetingParam.device_brand, 'brandDataAll')
      item.targetingParam.auto_extend_enabled && this.decompileKey(item.targetingParam.auto_extend_targets, 'autotendData')

      if (this.$refs.targeting && this.$refs.targeting[0]) {
        this.$refs.targeting[0].resetAudience()
        timeout(300).then(() => {
          this.autoSelectAudience(item)
        })
      }
      timeout(50).then(() => {
        this.show = true
      })
    },
    // 账号有选中的定位
    autoSelectAudience(item) {
      if (item && item.retargeting_tags) {
        const isTargeting = item.retargeting_tags.some((ret) => ret.excludes.length || ret.includes.length)
        if (this.$refs.targeting && isTargeting) {
          let current
          item.retargeting_tags.some((ret) => {
            if (ret.excludes.length || ret.includes.length) {
              current = ret.id
              return true
            }
          })
          if (current) this.$refs.targeting.currentRetarget(current)
        }
      }
    },
    // 账号有选中的媒体定位
    autoSelectMediaAudience(item) {
      const isTargeting = item.media_retargeting_tags.some((ret) => ret.mediaExcludes.length || ret.mediaIncludes.length)
      if (this.$refs.targeting && isTargeting) {
        let current
        item.media_retargeting_tags.some((ret) => {
          if (ret.mediaExcludes.length || ret.mediaIncludes.length) {
            this.$set(item, 'superior_popularity_type', 'CUSTOM')
            current = ret.id
            return true
          }
        })
        if (current) this.$refs.targeting.currentMediaRetarget(current)
      }
    },
    // 删除定向
    delTargeter(index) {
      const idx = this.targetPlan.findIndex((ret) => ret.check)
      const len = this.targetPlan.length
      if (len < 2) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: '不能删除最后一个定向'
        })
        return
      }
      // 删除自己
      if (index === idx) {
        if (index > 0) this.setTargeter(index - 1)
        else this.setTargeter(1)
      }
      this.targetPlan.splice(index, 1)
    },
    decompile(Ids, data) {
      if (!isArray(Ids) || !Ids.length) this.targetRadioChange(data)
      else {
        Ids.forEach((ret) => {
          const item = getKeyOfData(this[data], 'id', ret)
          this.$set(item, 'check', true)
          if (item.children && item.children.length) {
            item.children.forEach((met) => {
              this.$set(met, 'check', true)
            })
          }
        })
      }
    },
    decompileKey(vals, data) {
      if (!isArray(vals) || !vals.length) this.targetRadioChange(data)
      else {
        vals.forEach((ret) => {
          const item = getKeyOfData(this[data], 'key', ret)
          this.$set(item, 'check', true)
        })
      }
    },
    // 建议出价
    getBidSuggest() {
      const out = deepCopy(this.formItem)
      const target = deepCopy(this.curTarget)
      const curParam = Object.assign({}, out, target)
      const params = Object.assign({}, curParam, {
        ad_account_id: this.account,
        retargeting_tags: undefined,
        action_tags: undefined,
        word_tags: undefined
      })
      if (params.gender === 'NONE') delete params.gender
      if (params.age === 'NONE') delete params.age
      if (params.carrier === 'NONE') delete params.carrier
      if (params.ac === 'NONE') delete params.ac
      if (params.platform === 'NONE') delete params.platform

      if (params.download_type === 'EXTERNAL_URL') delete params.download_url // 落地页不填
      if (params.tags === 'REFEREE') params.ad_tag = [0] // 系统推荐
      if (params.adjust_cpa === 0 && params.smart_bid_type === 'SMART_BID_CONSERVATIVE') params.cpa_bid = 0 // 自动出价

      this.pricing = true
      bidSuggest(params).then((data) => {
        this.pricing = false
        if (data) {
          data.suggested_bid && (this.suggestStat = data.suggested_bid)
          data.smart_budget_range && (this.suggestRange = data.smart_budget_range)
        }
      })
    },
    async suggestBudget() {
      const out = deepCopy(this.formItem)
      const target = deepCopy(this.curTarget)
      const curParam = Object.assign(out, target)
      const params = Object.assign({}, curParam, {
        ad_account_id: this.account,
        retargeting_tags: undefined,
        action_tags: undefined,
        word_tags: undefined
      })
      if (params.gender === 'NONE') delete params.gender
      if (params.age === 'NONE') delete params.age
      if (params.carrier === 'NONE') delete params.carrier
      if (params.ac === 'NONE') delete params.ac
      if (params.platform === 'NONE') delete params.platform

      if (params.download_type === 'EXTERNAL_URL') delete params.download_url // 落地页不填
      if (params.tags === 'REFEREE') params.ad_tag = [0] // 系统推荐
      if (params.adjust_cpa === 0 && params.smart_bid_type === 'SMART_BID_CONSERVATIVE') params.cpa_bid = 0 // 自动出价

      const data = await bidSuggest(params)
      return data
    },
    adjustment(params) {
      // 不限处理

      if (params.download_type === 'EXTERNAL_URL') delete params.download_url // 落地页不填
      if (params.tags === 'REFEREE') params.ad_tag = [0] // 系统推荐
      if (params.adjust_cpa === 0 && params.smart_bid_type === 'SMART_BID_CONSERVATIVE') params.cpa_bid = 0 // 自动出价
      // 穿山甲
      if (params.inventory_type?.length === 1 && params.inventory_type.includes('INVENTORY_UNION_SLOT')) {
        params.activate_type.includes('ONE_MONTH_2_THREE_MONTH') &&
          params.activate_type.splice(params.activate_type.indexOf('ONE_MONTH_2_THREE_MONTH'), 1)
      } else {
        // 非穿山甲
        delete params.union_video_type
      }
      if (params.superior_popularity_type && params.superior_popularity_type === 'CUSTOM') delete params.superior_popularity_type

      return params
    },
    valid() {
      const rules = [
        {
          name: 'formItem/plan_name',
          require: true,
          min: 3,
          max: 90,
          desc: '广告名称'
        },
        {
          name: 'formItem/game_id',
          require: true,
          min: 1,
          desc: '投放游戏'
        }
      ]
      return this.invalid(rules)
    },
    customValid(params) {
      const { cpa_bid, budget } = params.delivery_setting
      const { start_time, end_time } = params.delivery_setting
      const day = betweenTime(start_time, end_time) // 投放天数
      const lowBudget = 300 // 最低预算
      const totalBudget = day * lowBudget // 最低总预算
      let plan_name_length = getByteLen(params.plan_name)
      const err = []
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = params.plan_name.match(regexp)

      const isStarTaskAutoMaterialEnable = params.star_task?.star_task_id && params.star_auto_material_addition_switch === 'ON'

      if (isStarTaskAutoMaterialEnable) {
        if (params.delivery_mode === 'MANUAL') {
          err.push({ feild: '投放模式', msg: '星广联投任务开启自动优选素材时只能选择自动投放' })
        }
      }

      if (isArray(values)) {
        values.forEach((ret) => {
          ret === '{项目组名}' && (plan_name_length += 11)
          ret === '{计划组名}' && (plan_name_length += 11)
        })
      }

      if (params.app_promotion_type === 'RESERVE') {
        if (!params.subscribe_url.trim()) {
          err.push({ feild: '预约链接', msg: '请填写预约链接' })
        }
      }

      if (params.app_promotion_type === 'DOWNLOAD' && params.ch_platform_id === 2) {
        if (!params.download_url?.trim()) {
          err.push({ feild: '应用链接', msg: '请填写应用链接' })
        }
      }
      const { blue_flow_package_setting, blue_flow_package_id } = params.blue_flow_package || {}
      if (params.ad_type === 'SEARCH' && blue_flow_package_setting === 'ON') {
        if (!blue_flow_package_id) err.push({ feild: '蓝海流量', msg: '请选择蓝海流量包' })
      }

      // 搜索快投
      const { search_bid_ratio, delivery_mode, keywordSwitch } = params
      if (delivery_mode === 'MANUAL' && keywordSwitch) {
        if (search_bid_ratio) {
          const twoDigit = /^[0-9]+([.]{1}[0-9]{1,2})?$/
          if (Number(search_bid_ratio) >= 1 && Number(search_bid_ratio) <= 2) {
            if (!twoDigit.test(search_bid_ratio)) {
              err.push({ feild: '搜索快投', msg: '出价系数值小数点后最多两位' })
            }
          } else {
            err.push({ feild: '搜索快投', msg: '出价系数取值范围1.00 ~ 2.00' })
          }
        }
      }

      if (plan_name_length > 90) err.push({ feild: '广告名称', msg: `加入动态词后的长度${plan_name_length}，超过了90个字符` })

      // 预算设置

      if (params.delivery_setting.budget_mode === 'BUDGET_MODE_DAY' && budget < lowBudget) {
        err.push({ feild: '日预算', msg: `应大于${lowBudget}元` })
      } else if (params.delivery_setting.budget_mode === 'BUDGET_MODE_TOTAL' && budget < totalBudget) {
        err.push({ feild: '总预算', msg: `应大于${totalBudget}元` })
      }

      // 手机价格不能相同
      // if (isArray(this.curTarget.launch_price) && this.curTarget.launch_price[0] === this.curTarget.launch_price[1]) {
      //   err.push({ feild: '手机价格', msg: '价格区间不能相等' })
      // }

      // 定向版位必选
      // if (isArray(this.curTarget.inventory_type) && this.curTarget.inventory_type.length === 0) {
      //   err.push({ feild: '投放位置', msg: '定向版位不能为空' })
      // }

      // 自动投放时不能选定向的人群包
      // if (
      //   params.delivery_mode === 'PROCEDURAL' &&
      //   this.curTarget.audiences?.length &&
      //   this.curTarget.audiences[0].retargeting_tags_include?.length
      // ) {
      //   err.push({ feild: '人群包', msg: '自动投放时仅支持排除类型的人群包' })
      // }

      // 自动投放模式，参数处理
      if (params.delivery_mode === 'PROCEDURAL' && params.delivery_setting.bid_type !== 'NO_BID') {
        if (params.delivery_setting.bid_type === 'CUSTOM') {
          if (
            isEmpty(params.delivery_setting.cpa_bid) ||
            params.delivery_setting.cpa_bid < 0.1 ||
            params.delivery_setting.cpa_bid > 10000
          ) {
            err.push({ feild: '出价', msg: '出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (
            params.delivery_setting.deep_bid_type === 'DEEP_BID_MIN' &&
            (isEmpty(params.delivery_setting.deep_cpabid) ||
              params.delivery_setting.deep_cpabid < 0.1 ||
              params.delivery_setting.deep_cpabid > 10000)
          ) {
            err.push({ feild: '深度目标出价', msg: '深度优化出价不能为空，且出价范围需在0.1-10000元之间' })
          }

          if (
            params.delivery_setting.deep_bid_type === 'ROI_COEFFICIENT' &&
            (isEmpty(params.delivery_setting.roi_goal) || params.delivery_setting.roi_goal > 5)
          ) {
            err.push({ feild: 'ROI系数', msg: 'ROI系数不能为空，且出价不大于5' })
          }
          if (params.delivery_setting.cpa_bid > params.delivery_setting.budget) err.push({ feild: '出价', msg: '出价不能大于预算值' })
        }
      }

      return err
    },
    async submitToNext() {
      const params = this.adjustment()

      this.formErr = false
      this.errRes = [...this.valid(), ...this.customValid(params)] // 表单验证
      if (this.errRes.length) {
        this.formErr = true
        return // 如果错误中断
      }

      const inner_plan_params = pullKeys(
        [
          'plan_name',
          'ch_platform_id',
          'game_id',
          'agent',
          'proxy_account_id',
          'call_type',
          'landing_type',
          'land_page_id',
          'page_addr',
          'package',
          'monitor_template_id',
          'plan_auto_task_id',
          'media_targeting_id',
          'callback_switch'
        ],
        params
      )

      const outer_plan_params = pullKeys(
        [
          'landing_type',
          'app_type',
          'convert',
          'app_promotion_type',
          'marketing_goal',
          'ad_type',
          'download_url',
          'delivery_setting',
          'timeRange',
          'delivery_mode'
        ],
        params
      )

      const targetings = this.targetPlan.map((ret) => {
        ret.targetingParam.audiences = ret.targetingParam.retargeting_tags.map((met) => {
          return {
            account_id: met.id,
            retargeting_tags_include: isArray(met.includes) ? met.includes.map((m) => m.id) : [],
            retargeting_tags_exclude: isArray(met.excludes) ? met.excludes.map((m) => m.id) : []
          }
        })
        ret.targetingParam.mediaAudiences = ret.targetingParam.media_retargeting_tags.map((met) => {
          return {
            account_id: met.id,
            flow_package: isArray(met.mediaIncludes) ? met.mediaIncludes.map((m) => m.id) : [],
            exclude_flow_package: isArray(met.mediaExcludes) ? met.mediaExcludes.map((m) => m.id) : []
          }
        })

        return ret
      })
      console.log(targetings)

      // 自动出价  系统推荐
      if (params.smart_bid_type === 'SMART_BID_CONSERVATIVE' && params.adjust_cpa === 0) {
        const data = await this.suggestBudget()
        if (data && isArray(data.smart_bid_range) && params.budget < data.smart_bid_range[1]) {
          // 自动出价高于预算
          this.$Message.error('自动出价时，系统计算出价高于预算值，请调高“预算”的值！')
          return
        } else if (!data) {
          throw new Error('获取系统推荐的自动出价时报错')
        } else if (!isArray(data.smart_bid_range)) {
          throw new Error('接口返回错误，缺少参数值‘smart_bid_range’')
        }
      }

      // 保存并修改
      setSession('inner_plan_params', inner_plan_params)
      setSession('outer_plan_params', outer_plan_params)
      setSession('targetings', targetings)

      // 转化计划
      if (this.formItem.ad === 'CONVERSION') this.convertModel = true
      else this.jump()
    },
    jump() {
      if (this.editState) this.$router.push({ name: 'localidea', query: { t: 'edit' } })
      else this.$router.push({ name: 'localidea' })
    }
  },
  created() {
    // this.weektimeData = weektimeData
  }
}
